var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOdogwuCashoutPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 79,
    viewBox: "0 0 176 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.925 43.2934C170.194 51.5615 159.166 59.1499 151.709 59.8295C109.382 63.3406 66.9497 63.3406 24.6226 59.8295C17.0604 59.1499 6.13723 51.5615 3.40645 43.2934C2.25111 39.5558 1.41086 35.8181 1.09577 32.0805C0.465589 40.2353 1.20081 48.2768 3.40645 56.4316C6.13723 66.1721 17.1654 74.8933 24.6226 75.7994C67.0547 79.8768 109.382 79.8768 151.709 75.7994C159.271 75.0065 170.194 66.1721 172.925 56.4316C175.131 48.2768 175.866 40.2353 175.236 32.0805C174.921 35.8181 174.08 39.5558 172.925 43.2934Z",
    fill: "#540B00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.71 67.7586C109.383 71.4962 66.9507 71.2697 24.6236 67.7586C17.0614 67.079 6.13823 59.4906 3.40744 51.2225C0.0464777 40.5759 0.0464777 29.8161 3.40744 19.1695C6.13823 10.9014 17.1664 3.31286 24.6236 2.6333C67.0557 -0.877806 109.383 -0.877806 151.71 2.6333C159.272 3.31286 170.195 10.7882 172.926 19.1695C176.287 29.8161 176.287 40.5759 172.926 51.2225C170.195 59.4906 159.167 67.079 151.71 67.7586Z",
    fill: "url(#paint0_linear_4948_66218)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M6.03125 46.1246C20.7355 36.0444 35.5448 26.0772 50.4591 16.2235C59.4917 10.3339 68.9444 5.12391 78.5021 0.140411C77.6619 0.140411 76.8216 0.140411 75.9814 0.140411C64.8482 5.80348 54.1351 12.1462 43.6321 18.9418C30.7133 27.3232 18.1098 36.2708 6.13638 46.0113L6.03125 46.1246Z",
    fill: "url(#paint1_linear_4948_66218)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M28.7188 66.6254C63.6938 43.067 99.2989 20.4147 136.48 1.61333C131.648 1.27354 126.817 1.04711 121.88 0.820587C104.55 11.0141 87.4305 21.5473 71.1509 33.6663C56.7617 44.3129 42.5827 55.2993 28.7188 66.6254Z",
    fill: "url(#paint2_linear_4948_66218)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M163.79 7.95485C163.79 7.95485 162.95 7.38852 162.53 7.04874C148.351 15.2036 134.172 23.2452 120.098 31.4C134.487 23.2452 149.086 15.2036 163.79 7.84165V7.95485Z",
    fill: "url(#paint3_linear_4948_66218)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M119.252 51.4477C137.002 40.5746 154.962 30.1546 173.237 20.5274C173.132 20.0743 173.027 19.7346 172.922 19.2815C172.922 18.9417 172.712 18.7152 172.607 18.3754C146.35 33.4392 119.672 48.05 95.4102 66.2851C103.287 61.1883 111.27 56.3179 119.252 51.4477Z",
    fill: "url(#paint4_linear_4948_66218)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M106.758 0.366982C103.607 0.366982 100.456 0.253673 97.2004 0.140411C93.7344 1.83933 90.3733 3.53839 86.9073 5.23731C62.9605 17.5828 41.0092 32.3067 18.5328 47.4837C14.3316 50.3153 10.1305 53.26 5.82422 56.0915C8.66003 59.9424 12.8612 63.2271 17.0624 65.379C32.8169 52.354 48.9915 39.782 65.2711 27.663C78.61 17.696 92.579 8.86164 106.653 0.253783L106.758 0.366982Z",
    fill: "url(#paint5_linear_4948_66218)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M44.3689 1.38596C37.752 1.72574 31.1351 2.1789 24.5182 2.74521C16.956 3.42478 6.03281 10.8999 3.30203 19.2813C1.62155 24.378 0.78125 29.5881 0.78125 34.6848C14.3301 22.1128 29.0344 11.0132 44.4738 1.38596H44.3689Z",
    fill: "url(#paint6_linear_4948_66218)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M129.965 69.2295C130.91 69.2295 131.96 69.2295 132.906 69.1163C139.628 63.793 146.455 58.6962 153.282 53.4862C145.404 58.5829 137.737 64.0194 129.965 69.3427V69.2295Z",
    fill: "url(#paint7_linear_4948_66218)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M147.402 68.0973C148.873 68.0973 150.238 67.8708 151.709 67.7575C159.271 67.0779 170.194 59.4895 172.925 51.2214C173.345 49.9756 173.66 48.7296 173.975 47.3704C165.257 54.5059 156.33 61.1884 147.402 67.9841V68.0973Z",
    fill: "url(#paint8_linear_4948_66218)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M105.921 70.2487C106.761 69.4559 107.601 68.6632 108.441 67.8703C107.181 68.6632 105.921 69.4559 104.66 70.2487C105.08 70.2487 105.5 70.2487 105.815 70.2487H105.921Z",
    fill: "url(#paint9_linear_4948_66218)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M153.079 2.97169H152.869C113.693 21.4333 76.5119 44.5387 40.0664 68.8899C41.7469 68.8899 43.3224 69.1164 45.0028 69.1164C61.2825 57.224 78.6124 46.8038 95.6273 36.2705C114.533 24.6046 133.858 13.8448 152.974 2.85849L153.079 2.97169Z",
    fill: "url(#paint10_linear_4948_66218)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M70.8398 70.2495C72.9404 70.2495 75.0411 70.2495 77.1417 70.2495C84.9139 63.6803 93.0013 57.5643 101.299 51.788C91.1108 57.7909 80.9227 63.7937 70.8398 70.1363V70.2495Z",
    fill: "url(#paint11_linear_4948_66218)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.255 60.2826C106.125 63.1142 69.9946 63.0009 33.8642 60.2826C27.4574 59.7163 18.1096 53.9399 15.6939 47.5972C12.7531 39.4424 12.7531 31.1744 15.6939 23.0195C18.0046 16.6769 27.3524 10.9006 33.8642 10.3343C69.9946 7.61606 106.125 7.61606 142.255 10.3343C148.662 10.9006 158.01 16.6769 160.425 23.0195C163.366 31.1744 163.366 39.4424 160.425 47.5972C158.01 53.9399 148.767 59.7163 142.255 60.2826Z",
    fill: "#732200"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.263 14.525C106.133 11.8068 70.0028 11.8068 33.8725 14.525C27.4656 15.0913 18.1178 20.8676 15.7021 27.2102C14.5468 30.6081 13.8116 34.006 13.6016 37.4039C13.8116 40.8017 14.5468 44.1995 15.7021 47.5973C18.0128 53.94 27.3606 59.7164 33.8725 60.2827C70.0028 63.001 106.133 63.001 142.263 60.2827C148.67 59.7164 158.018 53.94 160.434 47.5973C161.589 44.1995 162.324 40.8017 162.534 37.4039C162.324 34.006 161.589 30.6081 160.434 27.2102C158.018 20.8676 148.775 15.0913 142.263 14.525Z",
    fill: "#732200"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4948_66218",
    x1: 74.1977,
    y1: -29.8727,
    x2: 103.878,
    y2: 89.7711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4948_66218",
    x1: 33.1291,
    y1: -19.6804,
    x2: 62.8099,
    y2: 99.9638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4948_66218",
    x1: 69.2604,
    y1: -28.6273,
    x2: 98.9411,
    y2: 91.0164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4948_66218",
    x1: 128.5,
    y1: -43.3528,
    x2: 158.181,
    y2: 76.4056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4948_66218",
    x1: 116.521,
    y1: -40.2941,
    x2: 146.202,
    y2: 79.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4948_66218",
    x1: 45.5255,
    y1: -22.7384,
    x2: 75.0871,
    y2: 96.9131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4948_66218",
    x1: 15.4855,
    y1: -15.2635,
    x2: 45.1662,
    y2: 104.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4948_66218",
    x1: 119.777,
    y1: -41.0866,
    x2: 149.457,
    y2: 78.5567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4948_66218",
    x1: 138.58,
    y1: -45.8438,
    x2: 168.261,
    y2: 73.9143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4948_66218",
    x1: 85.1245,
    y1: -31.7956,
    x2: 114.561,
    y2: 87.0605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4948_66218",
    x1: 82.1835,
    y1: -31.7995,
    x2: 111.864,
    y2: 87.8444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4948_66218",
    x1: 67.0587,
    y1: -28.0607,
    x2: 96.739,
    y2: 91.5825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdogwuCashoutPlus);
export default __webpack_public_path__ + "static/media/odogwu-cashout-plus.46f796969a672662cf6d141a704e3553.svg";
export { ForwardRef as ReactComponent };